<div class="row">
    <div class="col">
        <h3>
            Ingrese su dirección según el ejemplo: <b>{{ address }}</b>
        </h3>
    </div>
</div>
<form [formGroup]="form" (ngSubmit)="search()">
    <div class="row mb-0 mb-lg-3">
        <div class="col">
            <div class="form-group">
                <label class="form-label" for="via">Diagonal</label>
                <ng-select formControlName="via" id="via" [items]="roadTypes" bindLabel="display" bindValue="id" class="custom" placeholder="Seleccione" validCtrl> </ng-select>
            </div>
        </div>
        <div class="col">
            <div class="form-group">
                <label class="form-label" for="numero_via_principal">84</label>
                <input type="text" formControlName="numero_via_principal" id="numero_via_principal" class="form-control" validCtrl />
            </div>
        </div>
        <div class="col">
            <label class="form-label" for="letra_via_principal">B</label>
            <ng-select formControlName="letra_via_principal" id="letra_via_principal" [items]="letras" placeholder="Seleccione"> </ng-select>
        </div>
        <div class="col">
            <label class="form-label" for="prefijo">Bis</label>
            <select formControlName="prefijo" id="prefijo" class="form-control">
                <option value="" selected>Seleccione...</option>
                <option value="BIS">BIS</option>
            </select>
        </div>
        <div class="col">
            <label class="form-label" for="acompanante_prefijo">A</label>
            <ng-select formControlName="acompanante_prefijo" id="acompanante_prefijo" [items]="letras" placeholder="Seleccione"> </ng-select>
        </div>
        <div class="col">
            <label class="form-label" for="cuadrante">Sur</label>
            <ng-select formControlName="cuadrante" id="cuadrante" [items]="referenciaCardinal" placeholder="Seleccione"> </ng-select>
        </div>
    </div>
    <div class="row">
        <div class="col-1 text-center">
            <span><b>#</b></span>
            <br /><label>#</label>
        </div>
        <div class="col">
            <label class="form-label" for="numero_via_generadora">8</label>
            <input formControlName="numero_via_generadora" id="numero_via_generadora" type="text" class="form-control" validCtrl />
        </div>
        <div class="col">
            <label class="form-label" for="acompanante_numero_via_generadora">B</label>
            <ng-select formControlName="acompanante_numero_via_generadora" id="acompanante_numero_via_generadora" [items]="letras" placeholder="Seleccione"> </ng-select>
        </div>
        <div class="col-1 text-center">
            <span><b>-</b></span>
            <br /><label> - </label>
        </div>
        <div class="col">
            <label class="form-label" for="numero_placa">62</label>
            <input formControlName="numero_placa" id="numero_placa" type="text" class="form-control" validCtrl />
        </div>
        <div class="col">
            <label class="form-label" for="cuadrante_2">Este</label>
            <ng-select formControlName="cuadrante_2" id="cuadrante_2" [items]="referenciaCardinal" placeholder="Seleccione"> </ng-select>
        </div>
        <div class="col pt-4">
            <div class="d-grid">
                <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Buscar</button>
            </div>
        </div>
    </div>
</form>
